<template>
  <el-container class="boxContent">

    <div class="indexContent">
      <div class="SwiperBox"></div>
      <div id="main">
        <div id="left">
          <h2>公告列表</h2>
          <div id="title">
            <span style="display: flex; flex-wrap: nowrap">【快讯】青创·智能参加数字园区 “智库”先行大会并分享经验
              <div id="new">New</div>
            </span>
            <span>2023-2-27</span>
          </div>
          <p>
            2月21日，保定市满城区工业互联网一体化进园区“百城千园行”活动暨数字赋能创新“智库”启动大会召开。区委常委、开发区党工委书记、管委会主任辛健伟出席并讲话，区政府党组成员、副区长李西佳主持会议。区工信局局长朱建鸿宣读《开展实施数字赋能创新“智库”实施方案》。会上，保定青创智能科技有限公司作为“智库”成员单位获得荣誉聘书；保定青创智能科技有限公司与保定市云之家软件科技有限公司现场签署合作协议；永红机械集团自动化事业部经理刘海滨作了题为《“智库”先行数字化建设规划方案》的发言，分享数字化解决方法、成果及经验，并和与会企业就数字化转型问题和...
          </p>
        </div>
        <div id="right">
          <div class="right1">
            <div class="time">
              <p>星期三</p>
              <p>2-27</p>
            </div>
            <div class="per">
              <p class="cont">心系员工情暖新春 永红为全体员工发放春节福利</p>
              <p class="publish">发布人：Admin</p>
            </div>
            <div class="detail">
              <button>详情</button>
            </div>
          </div>
          <div class="right1">
            <div class="time">
              <p>星期三</p>
              <p>2-27</p>
            </div>
            <div class="per">
              <p class="cont">心系员工情暖新春 永红为全体员工发放春节福利</p>
              <p class="publish">发布人：Admin</p>
            </div>
            <div class="detail">
              <button>详情</button>
            </div>
          </div>
          <div class="right1">
            <div class="time">
              <p>星期三</p>
              <p>2-27</p>
            </div>
            <div class="per">
              <p class="cont">心系员工情暖新春 永红为全体员工发放春节福利</p>
              <p class="publish">发布人：Admin</p>
            </div>
            <div class="detail">
              <button>详情</button>
            </div>
          </div>
        </div>
        <div id="more">
          <button>查看所有</button>
        </div>
      </div>
      <div id="bottom">
        <div id="botleft">
          <!-- <img src="../assets/img/视频.png" alt="" /> -->
          <video  muted src="../assets/video/video.mp4" controls="controls" autoplay="autoplay"></video>
        </div>
        <div id="botright">
          <img src="../assets/img/地图.png" alt="" />
        </div>
      </div>
      <div id="foot">
        <p>Copyright © 2021 永红机械集团有限公司 All Rights Reserved.</p>
      </div>
    </div>
  </el-container>
</template>

<script>


export default {
  name: "YhongIndex",
  data() {
    return {};
  },
  mounted() {
  
  }
};
</script>


<style lang="scss" scoped>
.indexContent {
  width: 100%;
  position: relative;
}

/* 图片容器样式 */
.SwiperBox {
  width: 100%;
  height: 159px;
  box-sizing: border-box;
  background: rgb(117, 182, 184);
  cursor: pointer;
  background-image: url(../assets/img/yhong.png);
  background-size: contain;
}

/* 图片默认样式 */
.imgCss {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 159px;
  opacity: 0;
  transition: 0.8s;
  /* 淡入淡出过渡时间 */
}

/* 图片选中样式(继承上方默认样式) */
.ShowCss {
  opacity: 1;
}

/* 两个按钮共有的样式,也可直接使用箭头图片替代 */
.leftBtn,
.rightBtn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(109, 109, 109, 0.445);
  color: #fff;
  border-radius: 50%;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
}

.leftBtn {
  left: 10px;
}

.rightBtn {
  right: 10px;
}

/* 下方指示器盒子 */
.instBox {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 10px;
  display: flex;
}

/* 小圆点 */
.inst {
  width: 10px;
  height: 10px;
  border: 1px solid #ccc;
  margin-right: 8px;
  background: #fff;
  border-radius: 50%;
  cursor: pointer;
}

.inst:last-child {
  margin-right: 0px;
}

.instActv {
  border: 1px solid #fbfcfe;
  background: #fbfcfe;
}

.app {
  width: 100%;
  height: 160px;
  margin-top: 18px;
}

#main {
  width: 1400px;
  height: 331px;
  background-color: #fbfcfe;
  margin: 0 auto;
  margin-top: 24px;
  display: flex;
  justify-content: space-between;
  position: relative;
}

#more {
  width: 102px;
  height: 50px;
  background-color: #fbfcfe;
  position: absolute;
  top: 282px;
  right: 649px;
}

#more button {
  width: 102px;
  height: 27px;
  background: #004eff;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #fefefe;
  line-height: 24px;
  border-style: none;
}

#left {
  width: 700px;
  height: 280px;
  border-right: 1px solid #c9ced9;
}

#new {
  width: 32px;
  height: 12px;
  background: #fbfcfe;
  border: 1px solid #ff0000;
  border-radius: 4px;
  margin-left: 15px;
  width: 24px;
  height: 8px;
  font-size: 8px;
  font-family: Arial;
  font-weight: 400;
  color: #ff0000;
}

#left h2 {
  width: 64px;
  height: 17px;
  margin-left: 20px;
  margin-top: 22px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}

#left p {
  width: 659px;
  height: 133px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
  opacity: 0.8;
  margin-top: 20px;
  margin-left: 19px;
}

#right {
  width: 700px;
  height: 280px;
  display: flex;
  flex-wrap: wrap;
}

.right1 {
  width: 100%;
  height: 71px;
  display: flex;
  margin-top: 19px;
  margin-left: 19px;
}

.cont:hover {
  color: #004eff;
}

.detail button:hover {
  color: #ffffff;
  background-color: #ff6d5c;
}

.time:hover {
  background-color: #fff8e6;
}

.time {
  width: 57px;
  height: auto;
  background-color: #eef3fe;
  display: flex;
  flex-direction: column;
  padding-top: 20px;
}

.time p {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 400;
  color: #333333;
  margin-top: 4px;
}

.per {
  width: 398px;
  height: auto;
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  margin-left: 20px;
}

.cont {
  width: 398px;
  height: 14px;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  margin-top: 8px;
}

.publish {
  width: 86px;
  height: 13px;
  font-size: 12px;
  font-weight: 400;
  color: #333333;
  opacity: 0.8;
  margin-top: 8px;
}

.detail {
  width: 63px;
  height: auto;
  display: flex;
  align-items: center;
  margin-left: 120px;
}

.detail button {
  width: 63px;
  height: 21px;
  color: #004eff;
  line-height: 20px;
  background-color: #eef3fe;
  border: none;
}

#title {
  width: 650px;
  height: 15px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  margin-left: 21px;
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
}

#bottom {
  width: 1400px;
  height: 331px;
  margin: 0 auto;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}

#botleft {
  width: 691px;
  height: 331px;
  background-color: #fbfcfe;
  border: 1px solid rgb(135, 186, 209);
}

video {
  width: 100%;
  height: 100%;
  
  object-fit: fill;
}

#botright img {
  width: 691px;
  height: 331px;
}

#botright {
  width: 691px;
  height: 331px;
  background-color: #fbfcfe;
}

#foot {
  width: 100%;
  height: 48px;
  line-height: 45px;
  font-size: 12px;
  color: #333333;
  margin-top: 55px;
  border-top: 1px solid #cdd2db;
  text-align: center;
}
</style>